module.exports = __webpack_public_path__ + "static/img/cloestgene.3506a68.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/cloestgene.png
// module id = 67xi
// module chunks = 1